//import { part } from "../assets/expandable-icons";
//import { IconSelect } from "../__components/icon-select";
//import Select from 'react-select';

import { SelectFAQPosts } from '../__components/select-faq-posts';
import { SelectFAQGroups } from '../__components/select-faq-groups';
import { SelectFAQThemes } from '../__components/select-faq-themes/select-faq-themes';
import { setStyle, updateFaqItems } from '../__components/utility';
import { SketchPicker } from 'react-color';
import ReactColorPicker from '../__components/color-pickers/react-color-picker';
import ReactMultiColorPicker from '../__components/color-pickers/react-multi-color-picker';

// import WP core and 3rd party library functionality
const merge = require('deepmerge');
const { __ } = wp.i18n;
const { Component, Fragment } = wp.element;
const { applyFilters, doAction, createHooks } = wp.hooks;
const { InspectorControls } = wp.blockEditor;
const {
	Button,
	Modal,
	TextControl,
	CheckboxControl,
	SelectControl,
	PanelBody,
	PanelRow,
	ToggleControl,
	Tooltip,
	ColorPicker,
} = wp.components;

class Inspector extends Component {
	constructor(props) {
		super(props);

		this.state = {
			faqThemeEditStatus: false, // used to display individual UI controls to customize current FAQ theme
			displayColorPicker: false,
			// don't think this is needed anymore?
			color: {
				r: '241',
				g: '112',
				b: '19',
				a: '1',
			},
		};

		//console.log('PROPS 2020:', this.props);
		//console.log('ATTS 2020:', this.props.attributes);
		//console.log("JSON: ", textExpandDefaultAttr);
		//console.log("LOCALIZED: ", flexible_faqs_editor_data.text_expand.default);
		//console.log("PROPS ATTRIBUTES: ", props.attributes);
	}

	handleClick = () => {
		this.setState({
			displayColorPicker: !this.state.displayColorPicker,
		});
	};

	handleClose = () => {
		this.setState({ displayColorPicker: false });
	};

	handleChange = (color) => {
		this.setState({ color: color.rgb });
	};

	componentDidMount() {
		//console.log('componentDidMount[text]: inspector.js');
		// Update faq items if order manually changed between page loads
		// @TODO we don't need to implement this while using <ServerSideRender /> to render FAQs as they are updated for every change to an attribute. BUT, when we swap back to rendering FAQs in the editor via JS then we WILL need to add this back in. The endpoint may need fixing though as there were issues when the endpoint URL was last tested.
		//updateFaqItems(this.props);
	}

	componentDidUpdate(prevProps) {
		//const { attributes: { faqPostId, faqGroupId, faq_group_toggle, faqItems } } = this.props;
		//console.log('componentDidUpdate[text]: inspector.js', this.props);
		// Update faq items if toggle has been updated
		//if (prevProps.attributes.faq_group_toggle !== faq_group_toggle) {
		// @TODO we don't need to implement this while using <ServerSideRender /> to render FAQs as they are updated for every change to an attribute. BUT, when we swap back to rendering FAQs in the editor via JS then we WILL need to add this back in. The endpoint may need fixing though as there were issues when the endpoint URL was last tested.
		//updateFaqItems(this.props);
		//}
	}

	updateFaqGroupToggle = () => {
		const {
			attributes: { faq_group_toggle, faqGroupId, accordion_mode },
			setAttributes,
		} = this.props;
		let tmp_group = '';
		let tmp_accordion_mode = accordion_mode;

		// the 'group' attr. determines whether an FAQ post or FAQ group is displayed so this needs updating too when the toggle changes
		if (faq_group_toggle === false) {
			tmp_group = JSON.parse(faqGroupId).value;
		} else {
			// If toggling from group to single set of FAQs make sure accordion_mode is handled correctly.
			if (accordion_mode === 'group') {
				tmp_accordion_mode = 'set';
			}
		}

		//console.log('GROUP:', tmp_group);

		setAttributes({
			faq_group_toggle: !faq_group_toggle,
			group: tmp_group,
			accordion_mode: tmp_accordion_mode,
		});
	};

	setFaqThemeEditStatus = (val) => {
		//console.log('LOOK: ', this.props);

		this.setState({ faqThemeEditStatus: val });
	};

	render() {
		const {
			attributes: {
				faq_border,
				icon,
				rotate_icon,
				icon_expand_color,
				q_color,
				q_bg_color,
				a_color,
				faqThemeCustomizedStatus,
				faq_theme_select,
				faq_group_toggle,
				faqItems,
				faqGroupId,
				faqPostId,
				faq_separator,
				q_a_separator,
			},
			attributes,
			setAttributes,
		} = this.props;

		// const icon_options = flexible_faqs_editor_data.expand_icons.map(opt => {
		// 	return {
		// 		label: opt
		// 	};
		// });

		const question_panel_controls = applyFilters(
			'question-panel-controls',
			'',
			attributes,
			this.props
		);
		const answer_panel_controls = applyFilters(
			'answer-panel-controls',
			'',
			attributes,
			this.props
		);
		const faq_separator_enabled_controls = applyFilters(
			'faq-separator-enabled-controls',
			'',
			attributes,
			this.props
		);
		const q_a_separator_enabled_controls = applyFilters(
			'q-a-separator-enabled-controls',
			'',
			attributes,
			this.props
		);
		const icon_color_controls = applyFilters(
			'icon-color-controls',
			[
				{
					label: 'Icon expand color',
					value: icon_expand_color,
					update: 'icon_expand_color',
				},
			],
			attributes,
			this.props
		);
		const question_color_controls = applyFilters(
			'question-color-controls',
			[
				{
					index: 1,
					label: 'Text color',
					value: q_color,
					update: 'q_color',
				},
				{
					index: 2,
					label: 'Background color',
					value: q_bg_color,
					update: 'q_bg_color',
				},
			],
			attributes,
			this.props
		).sort(({ index: a }, { index: b }) => a - b);

		const answer_color_controls = applyFilters(
			'answer-color-controls',
			[{ label: 'Text color', value: a_color, update: 'a_color' }],
			attributes,
			this.props
		);
		const faq_container_panel_controls = applyFilters(
			'faq-container-panel-controls',
			'',
			attributes,
			this.props
		);
		const faq_general_settings_panel_controls = applyFilters(
			'faq-general-settings-panel-controls',
			'',
			attributes,
			this.props
		);
		const faq_item_controls = applyFilters(
			'faq-item-controls',
			<p>Please upgrade for additional FAQ item controls.</p>,
			attributes,
			this.props
		);
		const icon_panel_controls = applyFilters(
			'icon-panel-controls',
			'',
			attributes,
			this.props
		);
		const faq_accordion_mode_panel_controls = applyFilters(
			'faq-accordion-mode-panel-controls',
			'',
			attributes,
			this.props
		);

		return (
			<Fragment>
				<InspectorControls>
					<PanelBody
						className="faq-data-source-panel"
						title={__('FAQs Data Source', 'flexible-faqs')}
						initialOpen={true}
					>
						<PanelRow>
							<div style={{ width: '100%' }}>
								<ToggleControl
									label={
										faq_group_toggle
											? 'Select group of FAQs:'
											: 'Select single set of FAQs:'
									}
									checked={faq_group_toggle}
									onChange={this.updateFaqGroupToggle}
								/>
								<div>
									{faq_group_toggle ? (
										<SelectFAQGroups
											faq_group_toggle={faq_group_toggle}
											faqGroupId={faqGroupId}
											setAttributes={setAttributes}
										/>
									) : (
										<SelectFAQPosts
											faqItems={faqItems}
											faq_group_toggle={faq_group_toggle}
											faqPostId={faqPostId}
											setAttributes={setAttributes}
										/>
									)}
								</div>
							</div>
						</PanelRow>
					</PanelBody>
					{faq_general_settings_panel_controls}
					{faq_accordion_mode_panel_controls}
					<PanelBody
						className="faq-themes-panel"
						title={__('FAQ Theme', 'flexible-faqs')}
						initialOpen={true}
					>
						<PanelRow>
							<SelectFAQThemes
								coreThemes={
									flexible_faqs_editor_data.text_expand
								}
								endpoint={'custom_text_expand_themes'}
								attributes={attributes}
								setFaqThemeEditStatus={
									this.setFaqThemeEditStatus
								}
								faqThemeEditStatus={
									this.state.faqThemeEditStatus
								}
								faqThemeCustomizedStatus={
									faqThemeCustomizedStatus
								}
								faq_theme_select={faq_theme_select}
								setAttributes={setAttributes}
							/>
						</PanelRow>
					</PanelBody>
					{(faqThemeCustomizedStatus ||
						this.state.faqThemeEditStatus) && (
						<Fragment>
							<PanelBody
								className="faq-icon-expand-panel"
								title={__(
									'~ Icon Styles (expand/collapse)',
									'flexible-faqs'
								)}
								initialOpen={false}
							>
								<PanelRow className="expand-icon-row">
									<SelectControl
										label="Select Icon"
										value={icon}
										options={
											flexible_faqs_editor_data.expand_icons
										}
										onChange={(icon) =>
											setStyle('icon', icon, this.props)
										}
									/>
								</PanelRow>
								<PanelRow className="react-multi-color-picker">
									<ReactMultiColorPicker
										coreThemes={
											flexible_faqs_editor_data.text_expand
										}
										rawCoreThemes={
											flexible_faqs_editor_data.block_text_expand
										}
										cols={icon_color_controls}
										title="CSS Colors"
										attributes={attributes}
										setAttributes={setAttributes}
									/>
								</PanelRow>
								<PanelRow>
									<CheckboxControl
										label="Rotate icon when expanding?"
										checked={rotate_icon}
										onChange={(val) =>
											setStyle(
												'rotate_icon',
												val,
												this.props
											)
										}
									/>
								</PanelRow>
								{icon_panel_controls}
							</PanelBody>
							<PanelBody
								className="faq-question-panel"
								title={__('~ Question Styles', 'flexible-faqs')}
								initialOpen={false}
							>
								<PanelRow className="react-multi-color-picker">
									<ReactMultiColorPicker
										coreThemes={
											flexible_faqs_editor_data.text_expand
										}
										rawCoreThemes={
											flexible_faqs_editor_data.block_text_expand
										}
										cols={question_color_controls}
										title="CSS Colors"
										attributes={attributes}
										setAttributes={setAttributes}
									/>
								</PanelRow>
								{question_panel_controls}
							</PanelBody>
							<PanelBody
								title={__('~ Answer Styles', 'flexible-faqs')}
								initialOpen={false}
							>
								<PanelRow className="react-multi-color-picker">
									<ReactMultiColorPicker
										coreThemes={
											flexible_faqs_editor_data.text_expand
										}
										rawCoreThemes={
											flexible_faqs_editor_data.block_text_expand
										}
										cols={answer_color_controls}
										title="CSS Colors"
										attributes={attributes}
										setAttributes={setAttributes}
									/>
								</PanelRow>
								{answer_panel_controls}
							</PanelBody>
							{faq_container_panel_controls}
							<PanelBody
								title={__('~ FAQ Item Styles', 'flexible-faqs')}
								initialOpen={false}
							>
								{/*									<PanelRow className="faq-text-input-combo">
										<div>Border</div>
										<TextControl
											autoComplete="off"
											value={faq_border}
											onChange={(val) => setStyle('faq_border', val, this.props)}
										/>
						</PanelRow> */}
								{faq_item_controls}
							</PanelBody>
							<PanelBody
								title={__(
									'~ FAQ Separator Styles',
									'flexible-faqs'
								)}
								initialOpen={false}
							>
								<PanelRow className="toggle-qa-separator">
									<ToggleControl
										label="Separator between Q/A items"
										checked={q_a_separator}
										onChange={(val) =>
											setStyle(
												'q_a_separator',
												val,
												this.props
											)
										}
									/>
								</PanelRow>
								{q_a_separator && (
									<Fragment>
										{q_a_separator_enabled_controls}
									</Fragment>
								)}
								<PanelRow className="toggle-faq-separator">
									<ToggleControl
										label="Separator between FAQ items"
										checked={faq_separator}
										onChange={(val) =>
											setStyle(
												'faq_separator',
												val,
												this.props
											)
										}
									/>
								</PanelRow>
								{faq_separator && (
									<Fragment>
										{faq_separator_enabled_controls}
									</Fragment>
								)}
							</PanelBody>
						</Fragment>
					)}
				</InspectorControls>
			</Fragment>
		);
	}
}

export default Inspector;
